export class RequestLineItemModel {
      productId: any;
      itemCode: any;
      socCode: any;
      quantity: number;
}
